import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { useAuth } from "../../store/AuthContext";
import { offlineEnabled, isOffline } from "../../lib/offlineStore";
import { syncOffline } from "../../hooks/useOfflineSync";

// "Keep offline" star — only for customers whose account has Offline mode on. Starred vehicles are always in the laptop's offline copy.
export const OfflinePin = ({ vehicle }) => {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!vehicle || !offlineEnabled(user) || user.offline_session) return null;
  const pinned = (user.offline_pins || []).includes(vehicle.id);
  const toggle = async () => {
    if (isOffline()) { toast.error("Reconnect to change your offline vehicles"); return; }
    setBusy(true);
    try {
      await (pinned ? api.offlineUnpin(vehicle.id) : api.offlinePin(vehicle.id));
      await refresh?.();
      toast.success(pinned ? `${vehicle.make} ${vehicle.model} will no longer be kept offline` : `${vehicle.make} ${vehicle.model} kept offline on this computer`);
      syncOffline().catch(() => {});
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <button data-testid="offline-pin-btn" data-pinned={pinned ? "1" : "0"} onClick={toggle} disabled={busy} title={pinned ? "Kept offline on this computer — click to remove" : `Keep this vehicle on this computer for cutting without internet (${(user.offline_pins || []).length}/${user.offline?.cap || 50} starred)`}
      className={`flex h-8 flex-shrink-0 items-center gap-1 rounded-md border px-2 text-[11.5px] font-medium transition-colors ${pinned ? "border-[#f0c945]/60 bg-[#f0c945]/15 text-[#f0c945]" : "border-white/10 text-[#9aa0a8] hover:border-[#f0c945]/50 hover:text-[#f0c945]"}`}>
      <Star className={`h-3.5 w-3.5 ${pinned ? "fill-current" : ""}`} />{pinned ? "Kept offline" : "Keep offline"}
    </button>
  );
};
